module.exports = __webpack_public_path__ + "h5/static/img/coinGN-logo.b5bd8598.png";